import $ from "cash-dom";

const component = (function () {
    $(document).ready(function () {
        var isResizing = false;
        var resizeTimer;
        var delay = 250;

        window.addEventListener("resize", function () {
            if (!isResizing) {
                isResizing = true;
                window.dispatchEvent(new CustomEvent("resizeStart"));
            }

            clearTimeout(resizeTimer);

            resizeTimer = setTimeout(function () {
                isResizing = false;
                window.dispatchEvent(new CustomEvent("resizeEnd"));
            }, delay);
        });
    });
})();

export default component;
